import "./KTrucksMapSidebar.scss";
import Sidebar from "../mixins/sidebar";
import {
	formatCurrency,
	formatDate,
	formatDuration,
	formatTime
} from "kinnect-formatters";
import { gmapApi } from "vue2-google-maps";
import {
	VAlert,
	VBtn,
	VCol,
	VDivider,
	VIcon,
	VList,
	VListItem,
	VListItemContent,
	VListItemSubtitle,
	VListItemTitle,
	VSpacer,
	VSubheader,
	VToolbar,
	VToolbarTitle
} from "vuetify/lib";

export default {
	name: "KTrucksMapDetailsSidebar",

	props: { trip: Object },

	inject: [ "storeModuleName" ],

	mixins: [ Sidebar ],

	computed: {
		google: gmapApi,

		show: {
			get() {
				return this.$store.state[this.storeModuleName].detailsSidebar;
			},
			set( value ) {
				this.$store.dispatch( `${this.storeModuleName}/setDetailsSidebar`, value );
			}
		},

		tripDistance() {
			const latLngs = this.trip.history.map( item => new this.google.maps.LatLng( item.lat, item.lng ) );

			return this.convertMetersToMiles( this.google.maps.geometry.spherical.computeLength( latLngs ) );
		},

		genDateTime() {
			return <VList subheader>
				<VSubheader>Times</VSubheader>

				<VListItem>
					<VListItemContent>
						<VListItemTitle>Date</VListItemTitle>
						<VListItemSubtitle>
							{formatDate( this.trip.deliveryDate )}
						</VListItemSubtitle>
					</VListItemContent>
				</VListItem>

				<VListItem>
					<VListItemContent>
						<VListItemTitle>Begin Loading Time</VListItemTitle>
						<VListItemSubtitle>
							{formatTime( this.trip.loadingTime )}
						</VListItemSubtitle>
					</VListItemContent>
				</VListItem>

				<VListItem>
					<VListItemContent>
						<VListItemTitle>Departure Time</VListItemTitle>
						<VListItemSubtitle>
							{formatTime( this.trip.onrouteTime )}
						</VListItemSubtitle>
					</VListItemContent>
				</VListItem>

				<VListItem>
					<VListItemContent>
						<VListItemTitle>Return Time</VListItemTitle>
						<VListItemSubtitle>
							{formatTime( this.trip.completeTime )}
						</VListItemSubtitle>
					</VListItemContent>
				</VListItem>

				<VDivider></VDivider>
			</VList>;
		},

		genDuration() {
			const loadingTimestamp = new Date( `${this.trip.deliveryDate} ${this.trip.loadingTime}` );
			const onrouteTimestamp = new Date( `${this.trip.deliveryDate} ${this.trip.onrouteTime}` );
			const completeTimestamp = new Date( `${this.trip.deliveryDate} ${this.trip.completeTime}` );

			return <VList subheader>
				<VSubheader>Time Spent</VSubheader>

				<VListItem>
					<VListItemContent>
						<VListItemTitle>Loading</VListItemTitle>
						<VListItemSubtitle>
							{formatDuration( onrouteTimestamp - loadingTimestamp )}
						</VListItemSubtitle>
					</VListItemContent>
				</VListItem>

				<VListItem>
					<VListItemContent>
						<VListItemTitle>On Route</VListItemTitle>
						<VListItemSubtitle>
							{formatDuration( completeTimestamp - onrouteTimestamp )}
						</VListItemSubtitle>
					</VListItemContent>
				</VListItem>

				<VListItem>
					<VListItemContent>
						<VListItemTitle>Total</VListItemTitle>
						<VListItemSubtitle>
							{formatDuration( completeTimestamp - loadingTimestamp )}
						</VListItemSubtitle>
					</VListItemContent>
				</VListItem>

				<VDivider></VDivider>
			</VList>;
		},

		genDistance() {
			return <VList subheader>
				<VSubheader>Distance</VSubheader>

				<VListItem>
					<VListItemContent>
						<VListItemTitle>{this.tripDistance} miles</VListItemTitle>
					</VListItemContent>
				</VListItem>

				<VDivider></VDivider>
			</VList>;
		},

		genCost() {
			return <VList subheader>
				<VSubheader>Cost</VSubheader>

				<VListItem>
					<VListItemContent>
						<VListItemTitle>{formatCurrency( this.trip.cost )}</VListItemTitle>
					</VListItemContent>
				</VListItem>
			</VList>;
		},

		genSidebarContent() {
			if ( this.loading ) {
				return <div class="pa-0">
					<VAlert
						class="text-left ma-0"
						type="info"
					>Loading details...</VAlert>
				</div>;
			}

			return <div>
				{this.genDateTime}
				{this.genDuration}
				{this.genDistance}
				{this.genCost}
			</div>;
		}
	},

	methods: {
		convertMetersToMiles( meters ) {
			return Math.round( meters / 1609.344 );
		}
	},

	render() {
		if ( !this.show ) {
			return;
		}

		return <VCol class={[
			this.sidebarClasses,
			"pr-0"
		]}>
			<VToolbar flat class="transparent">
				<VToolbarTitle>Trip Details</VToolbarTitle>
				<VSpacer></VSpacer>
				<VBtn icon onClick={() => this.show = false}>
					<VIcon>close</VIcon>
				</VBtn>
			</VToolbar>

			<VDivider></VDivider>

			{this.genSidebarContent}
		</VCol>;
	}
};
